export default{
  hwxx: 'ຂໍ້ມູນສິນຄ້າ',
  dxyd: 'ເຂົ້າຮ່ວມອັກສອນໂປຣເເກຣມທົວໄປ',
  plzjxs: 'ເພີ່ມຈຳນວນຕູ້ເປັນຊຸດ',
  xzh: 'ເພີ່ມແຖວໃໝ່',
  sch: 'ລົບແຖວ',
  xuhao: 'ລໍາດັບ',
  xzhwmc: 'ເລືອກຊື່ຄ່າ',
  pinl: 'recursive',
  twbh: 'ຄວາມຮ້ອນໃຕ້ບໍ່',
  xianh: 'ເລກຕູ້',
  qsrxh: 'ກະລຸນາໃສ່ຊື່ເລກໂຕເລກໂຕເລກ',
  xianshu: 'Box genus',
  tielux: 'ຕູ້ທາງລົດໄຟ',
  zibeix: 'ຕູສວ່ນບຸກຄົນ',
  xianx: 'ຂະໜາດຕູ້',
  xianl: 'ຊະນິດຕູ້',
  kongz: 'ຊ່ອງຫວ່າງເປົ່າ',
  kong: '(ລົບຂໍ້ມູນທັງໝົດ)',
  zhong: 'ມີຄວາມຫຍັງ',
  baozhuan: 'ແພັກເກດ',
  cpchx: 'ຍ້າຍໄປທີ່ີໂຕເລືອກ',
  tielcdx: 'ເຄື່ອງມືອ້າງປະກອນກ່ຽວກັບ',
  tezx: 'ຂໍ້ມູນທີ່ຈົງ',
  cquch: 'ຍ່າຍໄປທີ່ແລະຖືກໄປທີ່',
  xiasch: 'ຮ້ອງໃຊ້ຄືນຄ່າສະເພາະ',
  sfh: 'ເລກຫັຍງຈັກຢ່າງຢູ່ໃນລົດຂົນສົ່ງ',
  zhognlqk: 'ນ້ຳໜັກ(kg)',
  jiage: 'ຄົນງ (ກູນ)',
  msg1: '*ລາຍລະອຽດສີນຄ້າ:ຖ້າວ່າໃນຈຸດຊື່ສີ້ນຄ້າຊອກບໍ່ເຫັນ,ແມ່ນສາມາດຂຽນຊື່ສີນຄ້າໃສ່,ແລ້ວເລືອກທີ່ປະເພດທີ່ຖືກກັບສີ້ນຄ້າ.ຖ້ານຳໃຊ້ຕູ້ສວນບຸກຄົນ ຖ້າໃນຕູ້ບໍ່ມີສີນຄ້າ,ຊື່ສີນຄ້າແມ່ນໃຫ້ເລືອກຕູ້ສວນບຸກຄົນ（ຫຼືຕູຄອນເທັນເນີ）',
  msg2: 'ຖ້າໃສ່ຊື່ສີ້ນຄ້າປະເພດອື່ນ（ເຊັ່ນ:ຕູເປົ່າ,ຕູ້ເປົ່າສວນບຸກຄົນແລະອື່ນໆ）ລະບົບຊິຄິດໄລ່ເປັນຕູ້ໜັກ.',
  ri: 'ວັນນີ້',
  rysxq: 'ແຜນຂົນສົ່ງປະຈຳວັນ',
  zyrq: 'ວັນທີ່ຂົນສົ່ງ',
  xzrq: 'ກະລຸນາເລືອກວັນທີ່',
  xqtcfs: 'ວິທີແຈ້ງແຜນຄວາມຕ້ອງການ',
  zjtcrxq: 'ການຕ້ອງການຂອງປະຈຸບັນ',
  syjdxq: 'ໃຊ້ຄວາມຕ້ອງການຂອງຂະບວນການຍ່າງທຳ',
  jdxqh: 'ເລກຄວາມຕ້ອງການປະຈຳເດືອນ',
  qsrjdxqh: 'ກະລຸນາໃສ່ແລກໂຕເລກທີ່ຕ້ອງການ',
  ches: 'ໂຕເລກໂທ',
  chec: 'ໂຕເລກໂຮງ',
  liang: 'ສອງສົ້ນ',
  ldwl: 'ການຂົນສົງລະຫວ່າງສະຖານີຕົ້ນທາງກັບປາຍທາງ',
  msg3: 'ອີງຕັ້ງຕ້ອງການທ່ານ,ເລືອກສະຖານີຕົ້ນທາງກັບປາຍທາງໃນການໄປຮັບ-ສົງ,ສາງແລະບໍລິການຂົນສົງອື່ນໆ',
  mdz: 'ຂົນສົງສີນຄ້າກັບມາເຂົ້າສາຖານີ',
  smqh: 'ກຳລັງອອກຈາກການຄົ້ນ.',
  zdm: 'ຂົນສົງສີນຄ້າຈາກສາຖານີໄປສົງ',
  lxrxm: 'ຊື່ຄົນຕິດຕໍ່',
  dianh: 'ໂທລະໂທ',
  qhdz: 'ກະລຸນາໃສ່ບັນທຶກ',
  qianmi: 'ພື້ນີ້',
  licheng: 'ໄລຍະທາງ',
  tyrqdjs: 'ຜູ້ຂົນສົງສີນຄ້າຢືນຢັນຈຳນວນງ',
  xuqsm: 'ຄວາມຕ້ອງການ ຄຳບັນຍາຍ',
  qhgsfy: 'ຄ່າໃຊ້ຈ່າຍໃນການໄປຮັບ-ສົງ',
  smsh: 'ຫນ່ວຍຄວາມຈຳນວຍຄວາມສະດວກ',
  shdz: 'ບັດຳເນີນການສົ່ງອອກ',
  tijiao: 'ສົ່ງອອກ',
  qink: 'ລົບຂໍ້ມູນທັງໝົດ',
  chax: 'ຄົ້ນຫາ ',
  yslx: 'ຮູບແບບການຂົນສົ່ງ',
  tuoyf: 'ສະຖານີຕົ້ນທາງ',
  souhf: 'ປ້າຍໄປທີ່ ',
  hwpm: 'ສິນຄ້າ',
  slcs: 'ວ່າຈຳນວຍຄວາມສະດວກຜູ້ໃຊ້',
  caoz: 'ການດຳເນີນການ',
  xuanzhe: 'ໂຕເລືອກ',
  xzjdxqh: 'ບໍ່ມີຄວາມຕ້ອງການຂອງຂະແໜງຮູບແບບ',
  shgsfy: 'ປະເມີນຄ່າໃຊ້ຈ່າຍສໍລັບການຂົນສົ່ງສິນຄ້າ',
}

